import { database } from 'firebase';
import moment from 'moment';
import { sortObject } from '@/utils/formatUtils';

const getUsers = (callback) => {
    database().ref('/Users').once('value').then((snapshot) => {
        callback(snapshot.val())
    });
};

const getStudents = (users) => {
    return Object.keys(users).map((key) => {
        const user = users[key];
        return user['User data'] && user['User data'].Name || ''
    });
};

const getClasses = (users) => {
    return users.reduce((classes, user) => {
        let registerDate = user.createdAt;
        // Only add users with full data and at trainee level
        if (user.accessLevel !== 'trainee') return classes;
        registerDate = moment(registerDate);

        const year = moment(registerDate).year();
        const term = moment(registerDate).quarter();

        if (!classes[year]) classes[year] = {};
        if (!classes[year][`term_${term}`]) classes[year][`term_${term}`] = {};
        classes[year][`term_${term}`][user.id] = user;
        return classes;
    }, {});
};

const getStudentsByClassName = ({ users, className }) => {
    return Object.keys(users).reduce((object, key) => {
        const user = users[key];
        if (user['User data'] && user['User data'].Institution === className) object[key] = user;
        return object;
    }, {});
};

export { getClasses, getStudents, getUsers, getStudentsByClassName }